/**
 * avatars/presets/textures/face.js
 * Sinh texture khuôn mặt (Face Texture) - Orchestrator
 */

import { drawFaceSpeciesAndHair } from './face/face-species-hair.js';
import { drawFaceEyesAndBrows } from './face/face-eyes.js';
import { drawFaceProfileOverlay } from './face/face-profile.js';
import { drawFaceBlush, drawFaceNoseAndAging, drawFaceMouth, drawFaceGlasses } from './face/face-features.js';

export function generateFaceTexture(ctx, size, options = {}) {
  // 1. Màu da nền
  ctx.fillStyle = options.skinColor || '#fcd5b5';
  ctx.fillRect(0, 0, size, size);

  // 1a, 1b: Hoa văn da sinh học chủng tộc & tóc viền trán
  drawFaceSpeciesAndHair(ctx, size, options);

  // 2: Má hồng (Blush)
  drawFaceBlush(ctx, size, options);

  // 3: Mắt & Lông mày (kể cả độc nhãn Cyclops và Alien), trả về eyeBox
  const eyeBox = drawFaceEyesAndBrows(ctx, size, options);

  // 3a: Overlay giới tính & tuổi (mi mắt nữ cho mọi kiểu mắt, son bóng)
  drawFaceProfileOverlay(ctx, size, { ...options, eyeBox });

  // 3b, 4: Sống mũi, nếp nhăn tuổi tác, nước mắt / mồ hôi
  drawFaceNoseAndAging(ctx, size, options);

  // 5: Miệng theo từng biểu cảm
  drawFaceMouth(ctx, size, options);

  // 6: Kính mắt phẳng tích hợp
  drawFaceGlasses(ctx, size, options);
}
